module.exports = __webpack_public_path__ + "img/taxi_demo-600x450.155739a4.jpg";